import { defineExperiment, loose } from "../defineExperiment";

export const WEB_PREMIUM_TRIAL = defineExperiment("WEB_PREMIUM_TRIAL", {
  enabled: loose.boolean(),
});
